import React, { useState } from 'react'
import axios from 'axios'

import './NovoChamado.css'

const NovoChamado = () => {
    const [suporte, setSuporte] = useState({
        user: localStorage.nomeE, data: new Date().toLocaleString(), tipo: '', mensagem: ''
    })

    const updateField = (e) => {
        const { name, value } = e.target
        setSuporte(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const save = () => {
        const url = '/api/suporte/postJuridico'
        axios.post(url, suporte)
            .then(res => {
                alert(res.data)
                window.location = `/juridico`
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            });
    }

    return (
        <React.Fragment>
            <div className="labelBuscaPed">
                <i className="bi bi-headphones iconeBuscaPed"></i>
                SUPORTE
            </div>
            <div className="caixaNovoChamado">
                <div className="labelSuporte">
                    NOVO CHAMADO
                </div>
                <span className='spanNovoChamadoMotivo'>Motivo</span>
                <select className='selectNovoChamadoMotivo'
                    name='tipo'
                    onChange={e => updateField(e)} >
                    <option value="" disabled selected></option>
                    <option value="Alterar Documento (Jurídico)">Alterar Documento</option>
                    <option value="Erro no Sistema (Jurídico)">Erro no Sistema</option>
                </select>
                <span className='spanNovoChamadoMensagem'>Mensagem</span>
                <textarea className='textareaNovoChamado'
                    name='mensagem'
                    onChange={e => updateField(e)}></textarea>
            </div>
            <button className="botaoNPed" onClick={() => save()}>ENVIAR</button>
        </React.Fragment>
    )
}

export default NovoChamado